import { Col, Colors, Ic3Dots, Row, Text } from 'basic-ui-lib';
import styled from 'styled-components';
import { IStore } from 'modules/store/interfaces/api';

interface StoreItemMobileProps {
  item: IStore;
  onClick?: () => void;
  onClickMenu?: () => void;
}

const StoreItemMobile = ({ item, onClick, onClickMenu }: StoreItemMobileProps) => {
  return (
    <Container onClick={onClick}>
      <Col gap={4} flex={1} alignItems='flex-start'>
        <Text body_1 medium color='primary.6'>
          {item.ownerName}
        </Text>
        <Text caption_3 regular>
          {item.storeName}
        </Text>
      </Col>
      <Row gap={16} alignItems='flex-start'>
        <Text caption_3 regular>
          {item.phone}
        </Text>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClickMenu?.();
          }}
        >
          <Ic3Dots width={20} height={20} fill={Colors.neutral.bg[7]} />
        </button>
      </Row>
    </Container>
  );
};

export default StoreItemMobile;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid ${Colors.neutral.bg[5]};
  background-color: ${Colors.neutral.bg[1]};
  border-radius: 8px;
`;
